import Vue from 'vue';
import moment from 'moment';
import 'moment-duration-format';

Vue.filter('formatEpochDate', (value, gmt) => {
  let tsValue = value;
  if (tsValue) {
    if (typeof tsValue === 'number') {
      tsValue = value * 1000;
    }

    const ts = moment.utc(tsValue);

    if (gmt) {
      return `${ts.format('MM.DD.YYYY h:mm:ss A')} GMT`;
    }
    const tz = new Date().toLocaleTimeString('en-us', { timeZoneName: 'short' }).split(' ')[2];
    return `${ts.local().format('MM.DD.YYYY h:mm:ss A')} ${tz}`;
  }
  return '';
});

Vue.filter('bytesToSize', (bytes) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  if (bytes === 0) return 'n/a';
  const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
  if (i === 0) return `${bytes} ${sizes[i]})`;
  return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
});

Vue.filter('secondsToString', (value) => {
  if (value) {
    return moment.duration(value, 'seconds').format('d [days], h [hours], m [minutes] s [seconds]');
  }
  return '';
});

Vue.filter('macModelImage', (modelName) => {
  let name = 'macbook';
  if (typeof modelName === 'string') {
    if (modelName.toLowerCase().includes('macbookpro')) {
      name = 'macbookpro';
    } else if (modelName.toLowerCase().includes('macpro')) {
      name = 'macpro';
    } else if (modelName.toLowerCase().includes('macmini')) {
      name = 'macmini';
    } else if (modelName.toLowerCase().includes('imac')) {
      name = 'imac';
    }
  }
  return name;
});
